import type { ReserveInfoRedirectTarget } from '~/lib/graphql/graphql'

type RedirectErrorTarget =
  | { type: ReserveInfoRedirectTarget }
  | { type: 'YAHOO_REAUTH_YID'; url: string }

type RedirectErrorTargetWithoutUrl = Exclude<RedirectErrorTarget, { url: string }>
type RedirectErrorTargetWithUrl = Extract<RedirectErrorTarget, { url: string }>

export class RedirectError extends Error {
  target: RedirectErrorTarget

  protected constructor(target: RedirectErrorTarget) {
    super(target.type)
    this.target = target
    this.name = 'RedirectError'
  }

  static withoutUrl(type: RedirectErrorTargetWithoutUrl['type']): RedirectError {
    return new RedirectError({ type })
  }

  static withUrl(type: RedirectErrorTargetWithUrl['type'], url: string): RedirectError {
    return new RedirectError({ type, url })
  }
}
